import * as fromDatatype from "../datatype-library/index";

export interface bl_pos_card_terminal_settlement_method_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  card_terminal_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
	payment_scheme: fromDatatype.VarcharDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_pos_card_terminal_settlement_method_RowClass implements bl_pos_card_terminal_settlement_method_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  card_terminal_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
	payment_scheme: fromDatatype.VarcharDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
}
